import request from '../utils/request';

// 政策导航相关接口（精简版本）
export interface PolicyItem {
  id?: number;
  fileName: string;
  businessCategory: string;
  documentNumber?: string;
  webLink?: string;
  issuanceDate?: string;
  jointIssuingUnit?: string;
  issuingAuthority?: string;
  content?: string;
  createTime?: string;
  createUser?: string;
  updateTime?: string;
  updateUser?: string;
  deleted?: number;
  remark?: string;
  
  // 兼容性字段
  category?: string;
  title?: string;
  issueDate?: string;
  fileUrl?: string;
}

export interface PolicyListParams {
  current?: number;
  size?: number;
  keyword?: string;
  businessCategory?: string;
  documentNumber?: string;
  startDate?: string;
  endDate?: string;
  dateRange?: string[];
  fileName?: string; // 添加fileName字段
  
  // 兼容性字段
  category?: string;
}

export interface PolicyListResponse {
  records: PolicyItem[];
  total: number;
  size: number;
  current: number;
  pages: number;
}

// 政策导航API
export const policyApi = {
  // 分页查询政策导航列表
  getList: (params: PolicyListParams) => 
    request<PolicyListResponse>({
      url: '/api/biz/policy/list',
      method: 'GET',
      params,
    }),

  // 根据ID查询政策导航
  getById: (id: number) =>
    request<PolicyItem>({
      url: `/api/biz/policy/${id}`,
      method: 'GET',
    }),

  // 根据业务分类查询政策导航
  getByCategory: (businessCategory: string) =>
    request<PolicyItem[]>({
      url: `/api/biz/policy/category/${businessCategory}`,
      method: 'GET',
    }),

  // 新增政策导航
  create: (data: PolicyItem) =>
    request<string>({
      url: '/api/biz/policy',
      method: 'POST',
      data,
    }),

  // 修改政策导航
  update: (data: PolicyItem) =>
    request<string>({
      url: '/api/biz/policy',
      method: 'PUT',
      data,
    }),

  // 删除政策导航
  delete: (id: number) =>
    request<string>({
      url: `/api/biz/policy/${id}`,
      method: 'DELETE',
    }),

  // 批量删除政策导航
  batchDelete: (ids: number[]) =>
    request<string>({
      url: '/api/biz/policy/batch',
      method: 'DELETE',
      data: ids,
    }),

  // 导出政策导航数据
  export: (params: PolicyListParams) =>
    request<Blob>({
      url: '/api/biz/policy/export',
      method: 'GET',
      params,
      responseType: 'blob',
      timeout: 300000, // 5分钟超时
    }),

  // 导入政策导航数据
  import: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return request<string>({
      url: '/api/biz/policy/import',
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // 下载导入模板
  downloadTemplate: () =>
    request<Blob>({
      url: '/api/biz/policy/template',
      method: 'GET',
      responseType: 'blob',
    }),
};


